import { render, staticRenderFns } from "./SendMailChangeTemplateConfirmation.vue?vue&type=template&id=12c76af2&"
import script from "./SendMailChangeTemplateConfirmation.vue?vue&type=script&lang=js&"
export * from "./SendMailChangeTemplateConfirmation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports